/**
 * 
 * User Store, field names and set values
 * 
 */

type json_response = {
  status: string | null;
  result: string[] | null;
  errno: number | null;
  ref: string | null;
  token: string | null;
}

type json_fecha = {
  sqldesde: string;
  sqlhasta: string;
  fechadesde: string;
  fechahasta: string;
  horasdesde: string;
  horashasta: string;
  diadesde: string;
  diahasta: string;
  compudays: number;
};

type json_vehicle = {
  cu: number;
  agid: number;
  ag: string;
  ve: string;
  grupo: string;
  idgrupo: number;
  vid: number;
  opt_ac: number;
  opt_pax: number;
  opt_maletas: number;
  opt_puertas: number;
  opt_trans: number;
  opt_fuel:number;
  nc: string;
  oid: string;
  provincia: number;
  iurl: string;
  af_iurl: null;
  ud: number;
  minalq: number;
  cuotaoneway: number | null;
  devoid: string;
  statuscode: string;
  cominterno: number;
  dimensiones: string;
  formapago: number;
  desc_ESP_C: string;
  desc_ESP_D: string;
  qid: string;
  sup: string | null;
  rvp: number | null;
  rvtoggle: string | null;
  km_extra: number | null;
  kmmax: number | null;
  kminc_gr: number | null;
  km_alt: string | null;
  cub4: number | null;
}

type json_vehicle_detail = json_vehicle & {
  kmincluidos: number;
  idproveedor: number;
  grupoexterno: string;
  idgrupoext: number | string;
  jurl: string | null;
  kurl: string | null;
  modelo: string;
  desc_ESP: string;
  desc_ESP_A: string;
  desc_ESP_B: string;
};




let reservaT: any[] = [];   // reervation texts
let reservaD: any[] = [];   // reservation values 

let search_type: string = "F";

let ciudad_dropdown_furgo: string[] = [];
let ciudad_dropdown_turismo: string[] = [];
let ciudades_index :string[][] = [];
let provincias_index: string[] = [];


let jsonAry :string[] = [];
let jsonDet :string[] = [];

let vehiculoAry : json_vehicle[] = [];

let page_id :string;  /* 2023-08 cache breaker */
let revend :string;   /* Dont think that its used */

// Proveedores: 
const provs :string[] = ["local", "onefurgo", "sixt", "atesa", "hertz",
   "europcar", "europcar_v3", "europcar_v2", "europcar_v4", "europcar_fr", "europcar_it"]; 

const provCt = provs.length;

// Sillas fixed internal commission: 
const comsillas = 0.1;
const IVA = 0.21;

// This is the code on the revendor site, so we have to set it to the code.
// Setters: 
function setPageId(s:string, w:string, l: string, r:string = ""){
  
  page_id = s;

  if (w == "Revendor") {
		// ! Never Happens... would be set to code here?
	} 

  reservaD[81] = w; 
  reservaD[82] = r;
  reservaD[86] = l;

  reservaD[83] = 0;   // How many times user searched.
  reservaD[84] = 0;   // Whether they modified form manually after presets
  reservaD[87] = window.location.pathname; // Page ID

  const start = new Date().toISOString();
  reservaD[0] = start.slice(0, 10) + " " + start.slice(11, 16);

}


function setSearchType(t:string){
  search_type = t;
}


function setVehicleAry (ary: json_vehicle[]) {
  vehiculoAry = [...vehiculoAry, ...ary];
}

export { json_response, json_fecha, json_vehicle, json_vehicle_detail,
        setSearchType, setPageId, setVehicleAry,
        reservaT, reservaD,search_type, 
        ciudad_dropdown_furgo, ciudad_dropdown_turismo, 
        ciudades_index, provincias_index,
        provs, provCt,
        jsonAry, jsonDet, 
        vehiculoAry, 
        page_id, 
        comsillas, IVA
       };
